module.exports = {
  message: {
      Resut:{
        title:'Result',
        session: 'Session',
        sessionAll: 'All',
        umpire: 'Umpire',
        serverUmpire:'Service Umpire',
        description1: 'There are no eligible matches at the moment.',
        description2: 'No matches have been scheduled for the tournament.',
        Medal: 'Medal',
        Gold: 'Gold',
        Silver: 'Silver',
        Bronze: 'Bronze',
        nodata:'No data.',
        noFile:'No data.',
        searchFile:'Please enter the file you want to search for'
      },
      SearchCond:{
        SearchAth: 'Athletes',
        SearchAthTips: 'Please enter athlete name',
        Court: 'Courts',
        CourtTips: 'Select',
        Status: 'Status',
        SearchBtn: 'Search'
      }
  },
}